import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useRouteMatch } from "react-router-dom";

import { ERROR_MESSAGE_UNEXPECTED_ERROR } from "../../../../utils/consts";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";
import Authorities from "../../../../auth/authorities";
import withAuthority from "../../../../components/Auth/withAuthority";
import { Box, Hidden } from "@material-ui/core";
import PageHeaderMobile from "../../../../components/common/PageHeader/PageHeaderMobile";

// 🔥 Firebase imports
import firebase from "firebase";
import { secondaryDb } from "../../../../utils/firebase/temp";
import {
  fetchAlertAvailabilityInfo,
  fetchAlertConfigInfo,
  getResetHour,
} from "../../../../services/insightApp/metrics";
import ResetConfigurationNode from "./ResetConfigurationNode";

type AlertItem = {
  id: string;
  label: string;
};

type AlertConfigInfo = {
  [key: string]: {
    configDetails: {
      alertName: string;
    };
  };
};

/**
 * SettingPage Component
 *
 * This component fetches and displays real-time metrics from Firebase
 * based on the selected locationId and updates automatically on DB changes.
 */
const SettingPage: React.FunctionComponent<{}> = () => {
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [hours, setHours] = useState(4);
  const match: any = useRouteMatch();
  const locationId = match?.params?.locationId;

  const getResetConfigInfo = async () => {
    try {
      const res = await getResetHour(locationId);
      setIsLoading(false);

     setHours(res?.data?.data?.hour || 4);
    } catch (error) {
      setIsLoading(false);
      // setError("Please try again later.");
    }
  };

  useEffect(() => {
    document.title = "Insight - Availability";
    getResetConfigInfo();
  }, [locationId]);

  return (
    <>
      <Hidden lgUp>
        <PageHeaderMobile />
      </Hidden>
      <Box style={{ marginTop: "18px" }}>
        <ResetConfigurationNode
          isLoading={isLoading}
          hours={hours}
        />
      </Box>
      <DefaultAlert
        open={!!error}
        handleClose={() => setError("")}
        message={error}
        severity="error"
      />
    </>
  );
};

export default withAuthority(SettingPage, Authorities.CUSTOMER_LIST_READ);
